<div
  class="example-container-table"
  [class.example-container-table--embedded]="viewOnly"
>
  <div
    *ngIf="viewOnly && !(dataSource?.data?.length)"
    class="table-expand-empty"
  >
    <mat-icon>confirmation_number</mat-icon>
    <p>Sin tickets para este servicio</p>
  </div>

  <table
    *ngIf="!viewOnly || dataSource?.data?.length"
    mat-table
    [dataSource]="dataSource"
    id="mi-tabla"
    [class.table-expand-mat--embedded]="viewOnly"
  >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="column-40"></th>
      <td mat-cell *matCellDef="let element" class="column-40">
        <mat-checkbox
          *ngIf="showChecboxOption(element)"
          [checked]="element.checked"
          (click)="$event.stopPropagation()"
          (change)="updateCheck(element, $event)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="ssff">
      <th mat-header-cell *matHeaderCellDef class="column-100">-</th>
      <td mat-cell *matCellDef="let element" class="column-100">
        <div
          *ngIf="file.ssffproduct"
          class="tag-ssff-base tag-ssff-active"
        >
          SSFF
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="fechaCreacion">
      <th mat-header-cell *matHeaderCellDef class="column-120">
        Fecha de Creación
      </th>
      <td mat-cell *matCellDef="let element" class="column-120">
        <div class="row-base gap-8 div-vertical-center">
          <span>
            {{
              element.createdAt
                ? (element.createdAt | customDate | date: "dd MMM yyyy")
                : "-"
            }}
          </span>
          <span
            *ngIf="element?.estadoTicket === 'CREADO'"
            class="tag-nuevo"
          >
            Nuevo
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="tipoTicket">
      <th mat-header-cell *matHeaderCellDef class="column-140">
        Tipo de Ticket
      </th>
      <td mat-cell *matCellDef="let element" class="column-140">
        <div class="row-base gap-8 div-center div-vertical-center">
          <div class="column-base" style="text-align: left">
            <ng-container *ngIf="element.ticketTipos?.length; else sinTipos">
              <div *ngFor="let item of element.ticketTipos">
                {{ item.cantidad }} -{{ item.tipo }}
              </div>
            </ng-container>
            <ng-template #sinTipos>-</ng-template>
          </div>
          <a
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="
              $event.stopPropagation(); openDialogEditarNumberTickets(element)
            "
            [disabled]="handleBlockEditNumberTickets(element)"
          >
            <i-tabler
              name="pencil"
              [ngClass]="
                !handleBlockEditNumberTickets(element)
                  ? 'icon-color'
                  : 'icon-blocked'
              "
            ></i-tabler>
          </a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="monto">
      <th mat-header-cell *matHeaderCellDef class="column-100">Monto</th>
      <td mat-cell *matCellDef="let element" class="column-100">
        <div class="row-base gap-8 div-center div-vertical-center">
          <div>
            {{ element.monto != null ? element.moneda : "" }}
            {{ element.monto != null ? (element.monto | formatNumber) : "-" }}
          </div>

          <a
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="$event.stopPropagation(); openDialogEditarMonto(element)"
            [disabled]="handleBlockEditMonto(element)"
          >
            <i-tabler
              name="pencil"
              [ngClass]="
                !handleBlockEditMonto(element) ? 'icon-color' : 'icon-blocked'
              "
            ></i-tabler>
          </a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="estadoTicket">
      <th mat-header-cell *matHeaderCellDef class="column-100">
        Estado de Ticket
      </th>
      <td mat-cell *matCellDef="let element" class="column-100">
        <ng-container [ngSwitch]="element?.estadoTicket">
          <div
            *ngSwitchCase="'RESERVADO'"
            class="tag-estado tag-estado-Reservado"
          >
            {{ estadoTicketLabel['RESERVADO'] }}
          </div>
          <div *ngSwitchCase="'CREADO'" class="tag-estado tag-estado-Creado">
            {{ estadoTicketLabel['CREADO'] }}
          </div>
          <div
            *ngSwitchCase="'EN_PROCESO'"
            class="tag-estado tag-estado-En-Proceso"
          >
            {{ estadoTicketLabel['EN_PROCESO'] }}
          </div>
          <div
            *ngSwitchCase="'CONFIRMADO'"
            class="tag-estado tag-estado-Confirmado"
          >
            {{ estadoTicketLabel['CONFIRMADO'] }}
          </div>

          <div *ngSwitchDefault>{{ element?.estadoTicket || "-" }}</div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="orderStatus">
      <th mat-header-cell *matHeaderCellDef class="column-100">Estado de OS</th>
      <td mat-cell *matCellDef="let element" class="column-100">
        <span
          *ngIf="element?.order?.orderStatus; else noTicketeriaOrderStatus"
          class="os-status"
          [attr.data-os-status]="element.order.orderStatus.toUpperCase()"
        >
          {{ element.order.orderStatus }}
        </span>
        <ng-template #noTicketeriaOrderStatus>-</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="idOS">
      <th mat-header-cell *matHeaderCellDef class="column-80">OS Generada</th>
      <td mat-cell *matCellDef="let element" class="column-80">
        <i-tabler
          name="circle-check"
          [ngClass]="
            element.hasOrder ? 'icon-added-active' : 'icon-added-deactive'
          "
        ></i-tabler>
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaOSGenerada">
      <th mat-header-cell *matHeaderCellDef class="column-90">
        Fecha de OS Generada
      </th>
      <td mat-cell *matCellDef="let element" class="column-90">
        {{
          element.order?.createdAt
            ? (element.order?.createdAt | customDate | date: "dd MMM yyyy")
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="orderNumber">
      <th mat-header-cell *matHeaderCellDef class="column-90">Nro. de OS</th>
      <td mat-cell *matCellDef="let element" class="column-90">
        {{ (element.order?.displayCode || element.order?.orderNumber) | nullToDash }}
      </td>
    </ng-container>

    <ng-container matColumnDef="verOS">
      <th mat-header-cell *matHeaderCellDef class="column-160">Acciones</th>
      <td
        mat-cell
        *matCellDef="let element"
        class="column-160"
        (click)="$event.stopPropagation()"
      >
        <app-services-os-actions
          *ngIf="isPreliminary(element); else ticketOsActions"
          [model]="allData"
          [row]="ticketServiceRow(element)"
          (modelChanged)="onTicketPreliminaryChanged(element)"
        ></app-services-os-actions>
        <ng-template #ticketOsActions>
        <div class="row-base" style="gap: 8px">
          <a
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="openDialogVerOS(element)"
            [disabled]="!element.order?.orderId"
          >
            <i-tabler
              name="file-type-pdf"
              [ngClass]="
                element.order?.orderId ? 'icon-green' : 'icon-blocked'
              "
            ></i-tabler>
          </a>

          <a
            *ngIf="!handleBlockByEstadoTicket(element, 'acciones')"
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="openDialogEliminarOS(element)"
          >
            <i-tabler
              name="trash"
              [ngClass]="
                !handleBlockByEstadoTicket(element, 'acciones') &&
                !handleBlockByEstadoOS(element, 'eliminar')
                  ? 'icon-color'
                  : 'icon-blocked'
              "
            ></i-tabler>
          </a>

          <a
            *ngIf="
              element.order?.orderStatus === 'EN PROCESO' ||
              element.order?.orderStatus === 'PROCESADO' ||
              element.order?.orderStatus === 'CONFIRMADO'
            "
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="openDialogNotaCreditoProveedorComponent(element)"
          >
            <i-tabler name="receipt-tax" class="icon-18"></i-tabler>
          </a>
        </div>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="scheduledPaymentDate">
      <th mat-header-cell *matHeaderCellDef class="column-120">
        Fecha de Pago Programada
      </th>
      <td mat-cell *matCellDef="let element; let i = index" class="column-120">
        <div class="row-base gap-8 div-center div-vertical-center">
          <div>
            {{
              element.order?.scheduledPaymentDate
                ? (element.order?.scheduledPaymentDate
                  | customDate
                  | date: "dd MMM yyyy")
                : "-"
            }}
          </div>

          <a
            mat-icon-button
            class="d-flex align-items-center justify-content-center"
            (click)="
              $event.stopPropagation(); openDialogEditarFechaPago(element)
            "
            [disabled]="handleBlockByEstadoOS(element, 'editarFechaPago')"
          >
            <i-tabler
              name="pencil"
              [ngClass]="
                !handleBlockByEstadoOS(element, 'editarFechaPago')
                  ? 'icon-color'
                  : 'icon-blocked'
              "
            ></i-tabler>
          </a>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="paidAt">
      <th mat-header-cell *matHeaderCellDef class="column-100">
        Fecha de Pago (Financials App)
      </th>
      <td mat-cell *matCellDef="let element; let i = index" class="column-100">
        {{
          element.order?.paidAt
            ? (element.order?.paidAt | customDate | date: "dd MMM yyyy")
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="orderObservation">
      <th mat-header-cell *matHeaderCellDef class="column-90">Observacion</th>
      <td mat-cell *matCellDef="let element" class="column-90">
        {{ element.order?.orderObservation | nullToDash }}
      </td>
    </ng-container>

    <ng-container matColumnDef="archivos">
      <th mat-header-cell *matHeaderCellDef class="column-80">Archivos</th>
      <td
        mat-cell
        *matCellDef="let element; let i = index"
        class="column-80"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
        "
      >
        <a
          mat-icon-button
          class="d-flex align-items-center justify-content-center"
          [disabled]="handleBlockByEstadoTicket(element, 'archivos')"
          (click)="$event.stopPropagation(); openDialogArchivo(element)"
        >
          <i-tabler
            name="file-search"
            [ngClass]="
              !handleBlockByEstadoTicket(element, 'archivos')
                ? 'icon-color'
                : 'icon-blocked'
            "
          ></i-tabler>
        </a>

        <span *ngIf="element.hasInvalidFechaOperacion">
          <mat-icon
            class="icon-edit"
            matTooltip="¡Atención! Existe una discrepancia entre la fecha de operación de este servicio y la fecha registrada en el archivo MAPI (Sales, Operations o Ticketeria). Por favor, revise ambos registros para corregir el conflicto."
            matTooltipClass="custom-tooltip-class"
            matTooltipPosition="above"
          >
            <i-tabler
              name="alert-circle"
              style="width: 24px; height: 24px; font-size: 24px; color: #d32f2f"
            ></i-tabler>
          </mat-icon>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [style.background-color]="row.hasInvalidFechaOperacion ? '#ffebee' : ''"
    ></tr>
  </table>
</div>
